import { render, staticRenderFns } from "./CategoryCard.vue?vue&type=template&id=70dbf557&scoped=true&"
import script from "./CategoryCard.vue?vue&type=script&lang=js&"
export * from "./CategoryCard.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCard.vue?vue&type=style&index=0&id=70dbf557&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dbf557",
  null
  
)

export default component.exports